import { useQuery } from 'react-query';
import { CreditBundle } from '../../../interfaces/credits.interface';
import { apiRQ } from '../../api';

const getCurrentCreditBundles = async (): Promise<CreditBundle[]> => {
  const resp = await apiRQ.get<CreditBundle[]>('/credits/');
  return resp.data || [];
};

export const useCreditsBundle = () => {
  return useQuery<CreditBundle[], Error>(['useCreditsBundle'], getCurrentCreditBundles, {
    cacheTime: 2000,
    staleTime: 2000,
    refetchOnWindowFocus: false,
  });
};
